<script>
  import axios from "axios"
  import ApplicationState from "../../../Stores/applicationStates"
  import { onMount } from "svelte"
  import Navbar from "../../../Shared/Navbar/index.svelte"
  import Footer from "../../../Shared/footer.svelte"
  import Table from "../../../Shared/Table/table.svelte"
  import Chart from "./Components/chart.svelte"
  import List from "../SinDocAnalytics/Components/emailList.svelte"
  import Stats from "./Components/stats.svelte"
  import Filter from "../Email/Components/filter.svelte"
  import notify from "../../../Script/notify"
  import LoadingScreen from "../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import { querystring, push } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../Script/queryString"
  import DaysDropdown from "../Document/Components/daysDropdown.svelte"
  import AnalyticsFilter from "../Document/Components/analyticsFilter.svelte"
  import { getRequest } from "../../../Script/apiMethods"

  /**
   * @type {Object} - to store sent, bounced, open, delivered count
   */
  let statRate = {}
  /**
   * @type {Boolean} - for loading screen Show or hide
   */
  let apiCallBtnDisable

  /**
   * @type {Number} - how many list need to show
   */
  let limit

  /**
   * @type {Number} - which page list need to show
   */
  let page

  /**
   * @type {Number} - which order need to show (in order to date)
   */
  let sort

  /**
   * @type {Object} - object get from window location
   */
  let query

  /**
   * @type {Array} - it contains chart data
   */
  let chartData = []

  /**
   * @type {Array} - to store email log list data
   */
  let emailList = []

  /**
   * @type {Number} - to show pagination number for email log table
   */
  let emailListCount = 0

  /**
   * @type {String} start date for stats
   */
  let startDate = ""

  /**
   * @type {String} end date for stats
   */
  let endDate = new Date(Date.now()).toISOString()

  /**
   * @type {boolean} whether to show filter component or not
   */
  let showFilterForm = false
  /**
   * @type {boolean} whether to shoiw day dropdown or not
   */
  let daysModel = false

  /**
   * @type {Number} how many days we have to show data
   */
  let days = 7

  /**
   * this funtion fetch all stat data while page loading
   */
  onMount(async () => {
    try {
      apiCallBtnDisable = true
      query = queryStringToJSON($querystring)
      limit = query.limit ? query.limit : 10
      page = query.page ? query.page : 1
      sort = query.sort ? query.sort : -1
      // startDate = query.sdate ? query.sdate : "2021-09-07T00:00:00Z"

      days = query.days ? query.days : 7
      let a = 24 * 60 * 60 * 1000 * days
      let b = new Date().getTime()

      startDate = query.sdate ? query.sdate : new Date(b - a).toISOString()
      endDate = query.edate ? query.edate : new Date(Date.now()).toISOString()
      if (query.sdate) days = "Custom"

      await fetchAllDates()
    } catch (error) {
      const info = "PAGE: Email Analytics\nEVENT: onMount"
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  })

  /**
   * @description Fetch total count for viewed,verified,download.
   */
  const fetchStatCount = async () => {
    try {
      let sdate = startDate.slice(0, 10)
      let edate = endDate.slice(0, 10)
      let todayISODate = new Date().toISOString().slice(0, 10)

      if (query.sdate && todayISODate == sdate) {
        sdate = await reduceOneDate(sdate)
        sdate = new Date(sdate).toISOString()
        sdate = sdate.slice(0, 10)
      }
      if (query.sdate && todayISODate == edate) {
        edate = await reduceOneDate(edate)
        edate = new Date(edate).toISOString()
        edate = edate.slice(0, 10)
      }

      // console.log({ todayISODate }, { sdate }, { edate })

      // let todayDateInMS = new Date(todayISODate).getTime()
      // console.log(todayDateInMS)

      // let edate = new Date(startDate).getTime() - 86400000
      // edate = new Date(edate).toISOString()
      // edate = edate.slice(0, 10)
      // Fetching document template by ID
      // https://test.swagger.print2block.in/email/stat?sdate=2023-09-01&edate=2023-09-12

      const {
        data: { Sent, Bounced, Opens },
      } = await getRequest(`/api/swagger/v2/email/stat?sdate=${sdate}&edate=${edate}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      statRate = {
        sent: Sent,
        bounced: Bounced,
        open: Opens,
      }
    } catch (error) {
      throw error
    }
  }

  const reduceOneDate = (date) => {
    try {
      date = new Date(date).getTime() - 86400000
      date = new Date(date).toISOString()
      date = date.slice(0, 10)
      console.log(date)

      return date
    } catch (error) {
      console.log(error)
      throw error
    }
  }

  /**
   * @description Fetch total count for delivered.
   */
  const fetchDeliveredCount = async () => {
    try {
      let sdate = startDate
      let edate = endDate
      let todayISODate = new Date().toISOString().slice(0, 10)

      if (query.sdate && todayISODate == sdate.slice(0, 10)) {
        sdate = sdate.slice(0, 10)
        // sdate = await reduceOneDate(sdate)
        sdate = new Date(sdate).toISOString()
      }
      if (query.sdate && todayISODate == edate.slice(0, 10)) {
        edate = endDate.slice(0, 10)
        // edate = await reduceOneDate(edate)
        edate = new Date(edate).toISOString()
      }
      // console.log({ todayISODate }, { sdate }, { edate })

      // Fetching document template by ID
      // https://test.swagger.print2block.in/email/stat?sdate=2023-09-01&edate=2023-09-12
      const { data } = await axios.get(`/api/analytics/v2/email/stat?sdate=${sdate}&edate=${edate}&issuer=${$ApplicationState.issuerID}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      statRate.delivered = data.deliveredCount
    } catch (error) {
      throw error
    }
  }

  /**
   * @description Fetch viewed,verified, Download, issued count for chart Date.
   */
  const fetchChartData = async () => {
    try {
      let sdate = startDate
      let edate = endDate
      let todayISODate = new Date().toISOString().slice(0, 10)

      if (query.sdate && todayISODate == sdate.slice(0, 10)) {
        sdate = sdate.slice(0, 10)
        // sdate = await reduceOneDate(sdate)
        sdate = new Date(sdate).toISOString()
      }
      if (query.sdate && todayISODate == edate.slice(0, 10)) {
        edate = endDate.slice(0, 10)
        // edate = await reduceOneDate(edate)
        edate = new Date(edate).toISOString()
      }
      // console.log({ todayISODate }, { sdate }, { edate })

      // Fetching list of document templates
      const { data } = await getRequest(`/api/swagger/v2/email/chart?sdate=${sdate}&edate=${edate}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      chartData = data
    } catch (error) {
      throw error
    }
  }

  /**
   * @description Data Fetched for total email list.
   */
  const fetchEmailList = async () => {
    //test.swagger.print2block.in/analytics/email?doc=6502af6eac4aa2dd9885b547
    try {
      let sdate = startDate
      let edate = endDate
      // let todayISODate = new Date().toISOString().slice(0, 10)

      // if (query.sdate && todayISODate == sdate.slice(0, 10)) {
      //   sdate = await reduceOneDate(sdate)
      //   sdate = new Date(sdate).toISOString()
      //   // sdate = sdate.slice(0, 10)
      // }
      // if (query.sdate && todayISODate == edate.slice(0, 10)) {
      //   edate = await reduceOneDate(edate)
      //   edate = new Date(edate).toISOString()
      //   // edate = edate.slice(0, 10)
      // }
      // Fetching document template by ID
      // https://test.swagger.print2block.in/analytics/email?sdate=2023-09-01T00:00:00Z&edate=2023-09-15T00:00:00Z
      const { data, count } = await getRequest(`/api/analytics/v2/email?limit=${limit}&page=${page}&sort=${sort}&sdate=${sdate}&edate=${edate}&issuer=${$ApplicationState.issuerID}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      emailList = data
      emailListCount = count
      push(`/analytics/email?limit=${limit}&page=${page}&sort=${sort}${!query.sdate ? `&days=${days}` : `&sdate=${startDate}&edate=${endDate}`}`)
    } catch (error) {
      throw error
    }
  }

  /**
   * @description Function to fetch templates based on user input (Filter Component).
   */
  const whileChangingEntries = async (e) => {
    try {
      page = 1
      days = "Custom"
      apiCallBtnDisable = true
      if (e.detail.startDate) query.sdate = startDate = e.detail.startDate
      if (e.detail.endDate) query.edate = endDate = e.detail.endDate
      await fetchAllDates()
    } catch (error) {
      const info = "PAGE: Email Analytics\nEVENT: Error occurred while changing date filter."
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   * @description this functions runs when tables entiries are changed (Table Component).
   */
  const changeTableEntries = async (e) => {
    try {
      apiCallBtnDisable = true
      limit = e.detail.entries ? e.detail.entries : 10
      page = e.detail.activePage ? e.detail.activePage : 1
      sort = e.detail.sort ? e.detail.sort : -1
      await fetchEmailList()
    } catch (error) {
      const info = "PAGE: Email Analytics\nEVENT: Error occurred during actions such as sorting by date, changing display entries, or navigating pages."
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   * @description Function to reset the user inputs
   */
  const resetList = async () => {
    try {
      apiCallBtnDisable = true
      limit = 10
      page = 1
      sort = -1
      days = 7
      let a = 24 * 60 * 60 * 1000 * days
      let b = new Date().getTime()
      startDate = new Date(b - a).toISOString()
      endDate = new Date(Date.now()).toISOString()
      query.sdate = ""
      query.edate = ""
      // startDate = "2021-09-07T00:00:00Z"
      // endDate = new Date(Date.now()).toISOString()
      await fetchAllDates()
    } catch (error) {
      const info = "PAGE: Email Analytics\nEVENT: Error occurred while resetting date filter."
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   * @description This function called other all data fetching function
   */
  const fetchAllDates = async () => {
    try {
      await fetchStatCount()
      await fetchDeliveredCount()
      await fetchChartData()
      await fetchEmailList()
    } catch (error) {
      throw error
    }
  }

  /**
   * @description while change the days (7,30,60,90) count this function will run for changing respective dates
   */
  const getDaysToDate = async () => {
    try {
      page = 1
      daysModel = false
      apiCallBtnDisable = true
      let a = 24 * 60 * 60 * 1000 * days
      let b = new Date().getTime()
      startDate = new Date(b - a).toISOString()
      endDate = new Date(Date.now()).toISOString()
      query.sdate = ""
      query.edate = ""
      await fetchAllDates()
    } catch (error) {
      const info = "PAGE: Email Analytics\nEVENT: Error occurred while changing days filter."
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }
</script>

<svelte:head>
  <title>Email Analytics</title>
</svelte:head>
<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />

  {#if apiCallBtnDisable}
    <LoadingScreen msg={"Fetching Email Analytics"} />
  {/if}
  <div class="px-6">
    <div class="relative mx-auto mb-40 mt-10 h-auto w-full max-w-[920px]">
      <div class="flex select-none items-center justify-between">
        <div class="flex select-none flex-col gap-3 2xl:flex-row 2xl:items-center">
          <h1 class="text-2xl font-bold dark:text-white">Email Analytics</h1>
          <div class="hidden font-bold text-blue-500 md:block">
            {#if query && query.sdate}
              <!-- ({startDate.slice(0, 16)}) - ({endDate.slice(0, 16)}) -->
              <!-- {new Date(startDate).toUTCString().slice(0, 26)} - {new Date(endDate).toUTCString().slice(0, 26)} -->
              (After) {new Date(new Date(startDate).getTime() - new Date().getTimezoneOffset() * 60000).toUTCString().slice(0, 16)} - (Before) {new Date(new Date(endDate).getTime() - new Date().getTimezoneOffset() * 60000).toUTCString().slice(0, 16)}
            {:else}
              <div class="flex items-center gap-3">
                <span>
                  For last {days} days
                </span>
                <span data-tooltip="(After) {startDate} - (Before) {endDate}" tooltip-position="top">
                  <i class="fa-solid fa-circle-info" />
                </span>
              </div>
            {/if}
          </div>
        </div>
        <div class="relative flex w-3/5 items-center gap-3 mobile:w-fit">
          <DaysDropdown
            dropdownItems={[7, 30, 60, 90]}
            selected={days || 7}
            on:onToggleDropDown={() => (showFilterForm = false)}
            on:onSelect={(e) => {
              days = e.detail
              getDaysToDate()
            }}
          />
          <AnalyticsFilter on:reset={resetList} on:entriesChanged={whileChangingEntries} />
        </div>
      </div>

      <div class="relative mt-3 min-h-[530px] space-y-6 rounded-md bg-white p-6 dark:bg-mdGray md:p-12">
        <Stats {statRate} />
        <Chart {chartData} />
        <Table on:changeEntries={changeTableEntries} on:resetEntries={resetList} bind:activePage={page} title={"Email Log"} jsonData={emailList} count={emailListCount} search={false} nameSort={false}>
          {#if emailList.length}
            {#each emailList as json}
              <List {json} />
            {/each}
          {:else}
            <div class="text-secondary2 select-none rounded-md bg-[#f7f7f7] py-6 text-center text-2xl dark:bg-darkgray dark:text-white">There is no email log</div>
          {/if}
        </Table>
      </div>
    </div>
  </div>
  <Footer />
</div>
